
import { defineComponent } from 'vue'
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    name: "welcome",
    setup() {
        const { t } = useI18n();

        return {
            t,
        }
        
    },
})
